// helpers/pdfViajes.js
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generarPDFviajeConDetalles = (v) => {
  const doc = new jsPDF();
  let y = 10;
  const resumen = calcularResumen(v);

  doc.setFontSize(14);
  doc.text(`Viaje Nro ${v.nroViaje}`, 14, y);
  y += 8;
  doc.setFontSize(10);
  doc.text(`Chofer: ${v.choferId?.nombre || '-'}`, 14, y);
  y += 5;
  doc.text(`Camión: ${v.camionId ? `${v.camionId.camion || ''} (${v.camionId.patente || ''})` : '-'}`, 14, y);
  y += 5;
  doc.text(`Tarifa por KM: $${v.tarifaPorKm}`, 14, y);
  y += 5;
  doc.text(`Fecha Comanda: ${v.comandaId?.fecha?.substring(0, 10) || '-'}`, 14, y);
  y += 7;

  const agregarTabla = (titulo, columnas, filas) => {
    doc.setFontSize(11);
    doc.text(titulo, 14, y);
    y += 4;
    doc.autoTable({
      startY: y,
      head: [columnas],
      body: filas,
      styles: { fontSize: 8, cellPadding: 1 },
      headStyles: { fillColor: [60, 60, 60], textColor: 255 },
      margin: { left: 10, right: 10 },
    });
    y = doc.lastAutoTable.finalY + 6;
  };

  if (v.tramos?.length) agregarTabla('Tramos', ['Fecha', 'Origen', 'Destino', 'Remito'], v.tramos.map(t => [t.fecha?.substring(0, 10) || '', t.origen, t.destino, t.remito]));
  if (v.combustible?.length) agregarTabla(
  'Combustible',
  ['Fecha', 'Litros', 'Monto', 'Pago', 'Estación', 'Localidad', 'Km Tablero'],
  v.combustible.map(c => [
    c.fecha?.substring(0, 10) || '',
    c.litros,
    `$${c.monto}`,
    c.metodoPago || '-',
    typeof c.estacion === 'object'
      ? c.estacion.estacion
      : (v.estaciones?.find(e => e._id === c.estacion)?.estacion || c.estacion || '-'),
    c.localidad || '-',
    c.kmTablero
  ])
);

  [
    { titulo: 'Viáticos', data: v.viaticos },
    { titulo: 'Adelantos', data: v.adelantos },
    { titulo: 'Gastos', data: v.gastos },
  ].forEach(({ titulo, data }) => {
    if (data?.length) agregarTabla(titulo, ['Descripción', 'Monto'], data.map(d => [d.descripcion, `$${d.monto}`]));
  });

agregarTabla('Resumen Final', ['Concepto', 'Monto'], [
  ['Total KM', resumen.totalKm],
  ['Valor KM', resumen.valorKm.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
  ['Valor del Viaje', resumen.valorViaje.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
  ['Total Combustible', resumen.totalCombustible.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
  ['Litros Cargados', resumen.totalLitros],
  ['Promedio de Consumo', `${resumen.promedioConsumo} km/L`],
  ['Viáticos', resumen.totalViaticos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
  ['Adelantos', resumen.totalAdelantos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
  ['Gastos', resumen.totalGastos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
  ['💰 Total a Cobrar', resumen.liquidacionFinal.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })],
]);


  doc.save(`Viaje-${v.nroViaje}.pdf`);
};

function calcularResumen(v) {
  const kmTableros = (v.combustible || []).map(c => Number(c.kmTablero)).filter(km => !isNaN(km));
  const totalKm = kmTableros.length >= 2 ? Math.max(...kmTableros) - Math.min(...kmTableros) : 0;
  const tarifa = Number(v.tarifaPorKm || 130);
  const totalLitros = (v.combustible || []).reduce((sum, c) => sum + Number(c.litros), 0);
  const totalCombustible = (v.combustible || []).reduce((sum, c) => sum + Number(c.monto), 0);
  const totalViaticos = (v.viaticos || []).reduce((sum, v) => sum + Number(v.monto), 0);
  const totalAdelantos = (v.adelantos || []).reduce((sum, a) => sum + Number(a.monto), 0);
  const totalGastos = (v.gastos || []).reduce((sum, g) => sum + Number(g.monto), 0);
  const promedioConsumo = totalLitros > 0 ? (totalKm / totalLitros).toFixed(2) : '-';
  const liquidacionFinal1 = (totalKm * tarifa) + totalViaticos;
  const liquidacionFinal2 =  totalAdelantos - totalGastos;
  const liquidacionFinal = liquidacionFinal1 - liquidacionFinal2;

return {
  totalKm,
  totalLitros,
  promedioConsumo,
  totalCombustible,
  totalViaticos,
  totalAdelantos,
  totalGastos,
  liquidacionFinal,
  valorKm: tarifa,
  valorViaje: totalKm * tarifa
};

}
